// File: @/components/analytics-providers.tsx

'use client';

import { c as _c } from "react/compiler-runtime";
import { GoogleAnalytics } from '@next/third-parties/google';
import { Analytics } from '@vercel/analytics/next';
import type { JSX } from 'react';
import { ENV } from '@/config/constants';

/**
 * Analytics providers component that only loads in production
 *
 * Includes:
 * - Vercel Analytics for performance monitoring
 * - Google Analytics for user behavior tracking
 *
 * Environment Detection:
 * - Production: Both providers load normally
 * - Development/Test: Returns null (no analytics loaded)
 *
 * Benefits:
 * - Prevents development activity from polluting production analytics
 * - Reduces bundle size in development builds
 * - Eliminates unnecessary network requests during local testing
 * - Avoids console warnings from missing/placeholder analytics IDs
 *
 * @returns Analytics components in production, null in development
 *
 * @example
 * // In layout.tsx
 * <AnalyticsProviders />
 */
export function AnalyticsProviders() {
  const $ = _c(1);
  if (!ENV.isProductionAnalytics) {
    return null;
  }
  const gaId = process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><Analytics />{gaId && <GoogleAnalytics gaId={gaId} />}</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}